/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputAdminStockMovement
 */
export interface InputAdminStockMovement {
    /**
     * 
     * @type {string}
     * @memberof InputAdminStockMovement
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof InputAdminStockMovement
     */
    movementType: InputAdminStockMovementMovementTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof InputAdminStockMovement
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof InputAdminStockMovement
     */
    stockItemId: number;
}


/**
 * @export
 */
export const InputAdminStockMovementMovementTypeEnum = {
    Add: 'add',
    Subtract: 'subtract',
    Recount: 'recount'
} as const;
export type InputAdminStockMovementMovementTypeEnum = typeof InputAdminStockMovementMovementTypeEnum[keyof typeof InputAdminStockMovementMovementTypeEnum];


/**
 * Check if a given object implements the InputAdminStockMovement interface.
 */
export function instanceOfInputAdminStockMovement(value: object): boolean {
    if (!('movementType' in value)) return false;
    if (!('quantity' in value)) return false;
    if (!('stockItemId' in value)) return false;
    return true;
}

export function InputAdminStockMovementFromJSON(json: any): InputAdminStockMovement {
    return InputAdminStockMovementFromJSONTyped(json, false);
}

export function InputAdminStockMovementFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminStockMovement {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'] == null ? undefined : json['comment'],
        'movementType': json['movementType'],
        'quantity': json['quantity'],
        'stockItemId': json['stockItemId'],
    };
}

export function InputAdminStockMovementToJSON(value?: InputAdminStockMovement | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'comment': value['comment'],
        'movementType': value['movementType'],
        'quantity': value['quantity'],
        'stockItemId': value['stockItemId'],
    };
}

